import { createEntityAdapter } from '@reduxjs/toolkit';

const defaultConfig = { idFieldName: 'id' };

const getAdapter = (config = {}) => {
  const { idFieldName } = { ...defaultConfig, ...config };
  return createEntityAdapter({
    selectId: (entity) => entity[idFieldName],
  });
};

export default getAdapter;
